import CloseIcon from "@mui/icons-material/Close";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import { Chip } from "@mui/material";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Stack from "@mui/material/Stack";

import { CabinsColors } from "@/constants/config";

const list = [
  {
    label: "<- Nonstop",
    color: "grey",
    icon: <StarBorderIcon />,
    value: "",
  },
  {
    label: "Economy",
    color: CabinsColors.economy,
    value: "Economy",
  },
  {
    label: "Premium",
    color: CabinsColors.premiumEconomy,
    value: "PremiumEconomy",
  },
  {
    label: "Business",
    color: CabinsColors.business,
    value: "Business",
  },
  {
    label: "First",
    color: CabinsColors.first,
    value: "First",
  },
];

export default function CustomSeparator(props: {
  onClose: () => void;
  onClick?: (v: string) => void;
}) {
  const breadcrumbs = list.map(({ label, color, icon, value }) => (
    <Chip
      key={label}
      icon={icon}
      label={label}
      size="small"
      sx={{
        borderRadius: 2,
        backgroundColor: color,
        fontWeight: 600,
        color: "white",
        ".MuiChip-icon": {
          color: "white",
        },
      }}
      clickable={label !== "Nonstop"}
      onClick={() => {
        props.onClick && props.onClick(value);
      }}
    />
  ));

  return (
    <div className="flex items-center">
      <Stack spacing={0} className="flex-wrap">
        <Breadcrumbs
          separator=""
          aria-label="breadcrumb"
          sx={{
            ".MuiBreadcrumbs-ol": {
              flexWrap: "nowrap",
            },
            ".MuiBreadcrumbs-separator": {
              margin: "0 4px",
            },
          }}
        >
          {breadcrumbs}
        </Breadcrumbs>
      </Stack>
      <CloseIcon sx={{fontSize:13}} className="ml-[10px]" color="primary" onClick={props.onClose} />
    </div>
  );
}
